import { gql } from "@apollo/client";

export const GET_DOMAINS = gql`
  query domains($input: DomainsInput!) {
    domains(input: $input) {
      total
      domains {
        id
        name
        avatar {
          name
          dir
          base
          mimetype
        }
        company {
          imageURL
        }
        companyKnowledgeBase
      }
    }
  }
`;
